export default __webpack_public_path__ + "static/media/contact.8c9085d9.png";